"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _string = require("@qwkin/string");
var _excluded = ["token"],
  _excluded2 = ["token"],
  _excluded3 = ["token"],
  _excluded4 = ["token"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token", "id", "type"],
  _excluded7 = ["token", "path", "origin"],
  _excluded8 = ["token", "id", "condo", "type", "unitId"],
  _excluded9 = ["token", "id", "userType"],
  _excluded10 = ["token"],
  _excluded11 = ["token", "id"],
  _excluded12 = ["token", "id"],
  _excluded13 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UnitService = exports.UnitService = /*#__PURE__*/(0, _createClass2["default"])(function UnitService() {
  (0, _classCallCheck2["default"])(this, UnitService);
});
(0, _defineProperty2["default"])(UnitService, "create", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).post('/unit', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UnitService, "list", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get('/units', {
    params: params
  });
});
(0, _defineProperty2["default"])(UnitService, "listFloors", function (_ref3) {
  var token = _ref3.token,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get("/unit/position/floor", {
    params: params
  });
});
(0, _defineProperty2["default"])(UnitService, "listLines", function (_ref4) {
  var token = _ref4.token,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).get("/unit/position/line", {
    params: params
  });
});
(0, _defineProperty2["default"])(UnitService, "get", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).get("/unit/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(UnitService, "delete", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id;
  return _Api["default"].withAuth(token)["delete"]("/unit/".concat(id));
});
(0, _defineProperty2["default"])(UnitService, "removeFromUnit", function (_ref7) {
  var token = _ref7.token,
    id = _ref7.id,
    type = _ref7.type,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded6);
  return _Api["default"].withAuth(token).post("/unit/".concat(id, "/remove/").concat(type.toLowerCase()), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UnitService, "editResidentFromUnit", function (_ref8) {
  var token = _ref8.token,
    path = _ref8.path,
    origin = _ref8.origin,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded7);
  if (origin) {
    return _Api["default"].withAuth(token).post("/unit/changeResidentType/".concat((0, _string.mapResidentTypeToUrl)(origin)), _objectSpread({}, params));
  }
  return _Api["default"].withAuth(token).post("/user/edit/".concat(path), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UnitService, "patchResidentTypeFromUnit", function (_ref9) {
  var token = _ref9.token,
    unitId = _ref9.unitId,
    type = _ref9.type;
  var fixedType = _objectSpread(_objectSpread({}, type), {}, {
    origin: type.origin.toLowerCase(),
    destination: type.destination.toLowerCase()
  });
  return _Api["default"].withAuth(token).post("/unit/".concat(unitId, "/change/residentType/"), _objectSpread({}, fixedType));
});
(0, _defineProperty2["default"])(UnitService, "patchResidentFromUnit", function (_ref10) {
  var token = _ref10.token,
    id = _ref10.id,
    condo = _ref10.condo,
    type = _ref10.type,
    unitId = _ref10.unitId,
    params = (0, _objectWithoutProperties2["default"])(_ref10, _excluded8);
  return _Api["default"].withAuth(token).patch("/user/".concat(id), _objectSpread({}, params), {
    params: {
      condo: condo
    }
  });
});
(0, _defineProperty2["default"])(UnitService, "addResidentToUnit", function (_ref11) {
  var token = _ref11.token,
    id = _ref11.id,
    userType = _ref11.userType,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded9);
  return _Api["default"].withAuth(token).post("/unit/".concat(id, "/add/").concat(userType), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UnitService, "searchResidentByPhoneOrEmail", function (_ref12) {
  var token = _ref12.token,
    params = (0, _objectWithoutProperties2["default"])(_ref12, _excluded10);
  return _Api["default"].withAuth(token).get('/user/searchBy', {
    params: params
  });
});
(0, _defineProperty2["default"])(UnitService, "expireAmenityCard", function (_ref13) {
  var token = _ref13.token,
    id = _ref13.id;
  return _Api["default"].withAuth(token).post("/amenityCard/".concat(id, "/expire"));
});
(0, _defineProperty2["default"])(UnitService, "deleteAmenityCard", function (_ref14) {
  var token = _ref14.token,
    id = _ref14.id;
  return _Api["default"].withAuth(token)["delete"]("/amenityCard/".concat(id));
});
(0, _defineProperty2["default"])(UnitService, "createAmenityCard", function (_ref15) {
  var token = _ref15.token,
    id = _ref15.id,
    params = (0, _objectWithoutProperties2["default"])(_ref15, _excluded11);
  return _Api["default"].withAuth(token).post("/amenityCard", _objectSpread({}, params));
});
// TODO: Paginate
(0, _defineProperty2["default"])(UnitService, "listAmenityCards", function (_ref16) {
  var token = _ref16.token,
    id = _ref16.id;
  return _Api["default"].withAuth(token).get("/amenityCard", {
    params: {
      unit: id,
      page: 1,
      limit: 20
    }
  });
});
(0, _defineProperty2["default"])(UnitService, "editAmenityCard", function (_ref17) {
  var token = _ref17.token,
    id = _ref17.id,
    params = (0, _objectWithoutProperties2["default"])(_ref17, _excluded12);
  return _Api["default"].withAuth(token).patch("/amenityCard/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UnitService, "sendAmenityCardLink", function (_ref18) {
  var token = _ref18.token,
    id = _ref18.id,
    params = (0, _objectWithoutProperties2["default"])(_ref18, _excluded13);
  return _Api["default"].withAuth(token).post("/amenityCard/".concat(id, "/sendLink"), _objectSpread({}, params));
});